<template>
    <div class="collapse-icon accordion-icon-rotate left">
        <div id="headingCollapse22" class="card-header">
            <a data-toggle="collapse" href="#collapse22" class="lead">{{ $t("labels.newEvent") }}</a>
        </div>
        <div id="collapse22" class="collapse hide">
            <form class="form">
                <div class="row bottom-space">
                    <div class="col-md-12">
                        <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="periodic" v-model="event.periodic">
                            <label class="custom-control-label float-left" for="periodic">{{ $t("labels.periodic") }}</label>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="event.periodic === false">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="startDate">{{ $t("labels.startDate") }}</label>
                            <date-picker v-model="event.startDate" type="datetime" width="100%" format="DD/MM/YYYY HH:mm" :lang="$i18n.locale" :time-picker-options="{start: '06:00', step:'00:10' , end: '20:00'}"></date-picker>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="endDate">{{ $t("labels.endDate") }}</label>
                            <date-picker v-model="event.endDate" type="datetime" width="100%" format="DD/MM/YYYY HH:mm" :lang="$i18n.locale" :time-picker-options="{start: '06:00', step:'00:10' , end: '20:00'}"></date-picker>
                        </div>
                    </div>
                </div>
                <div class="row" v-else>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label for="periodStart">{{ $t("labels.periodStart") }}</label>
                            <date-picker v-model="event.periodStart" width="100%" format="DD/MM/YYYY" :lang="$i18n.locale"></date-picker>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label for="periodEnd">{{ $t("labels.periodEnd") }}</label>
                            <date-picker v-model="event.periodEnd" width="100%" format="DD/MM/YYYY" :lang="$i18n.locale"></date-picker>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label for="periodStep">{{ $t("labels.periodStep") }}</label>
                            <select class="form-control" v-model="event.periodStep">
                                <option value="weeks">{{ $t("labels.weeks") }}</option>
                                <option value="months">{{ $t("labels.months") }}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="event.periodStep === 'weeks' && event.periodic === true">
                    <div class="col-md-4">
                        <div class="form-group">
                            <label for="dayOfWeek">{{ $t("labels.dayOfWeek") }}</label>
                            <select class="form-control" v-model="event.dayOfWeek">
                                <option value="1">{{ $t("labels.monday") }}</option>
                                <option value="2">{{ $t("labels.tuesday") }}</option>
                                <option value="3">{{ $t("labels.wednesday") }}</option>
                                <option value="4">{{ $t("labels.thursday") }}</option>
                                <option value="5">{{ $t("labels.friday") }}</option>
                                <option value="6">{{ $t("labels.saturday") }}</option>
                                <option value="7">{{ $t("labels.sunday") }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-4">
                       <div class="form-group">
                            <label for="dailyStart">{{ $t("labels.dailyStart") }}</label>
                            <date-picker v-model="event.dailyStart" width="100%" :lang="$i18n.locale" type="time" format="HH:mm:ss a" placeholder="Select Time" confirm></date-picker>
                        </div>
                    </div>
                    <div class="col-md-4">
                       <div class="form-group">
                            <label for="dailyEnd">{{ $t("labels.dailyEnd") }}</label>
                            <date-picker v-model="event.dailyEnd" width="100%" :lang="$i18n.locale" type="time" format="HH:mm:ss a" placeholder="Select Time" confirm></date-picker>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="event.periodStep === 'months' && event.periodic === true">
                    <div class="col-md-4">
                        <div class="form-group">
                            <label for="dayOfMonth">{{ $t("labels.dayOfMonth") }}</label>
                            <input type="number" class="form-control" v-model="event.dayOfMonth">
                        </div>
                    </div>
                    <div class="col-md-4">
                       <div class="form-group">
                            <label for="dailyStart">{{ $t("labels.dailyStart") }}</label>
                            <date-picker v-model="event.dailyStart" width="100%" :lang="$i18n.locale" type="time" format="HH:mm:ss a" placeholder="Select Time" confirm></date-picker>
                        </div>
                    </div>
                    <div class="col-md-4">
                       <div class="form-group">
                            <label for="dailyEnd">{{ $t("labels.dailyEnd") }}</label>
                            <date-picker v-model="event.dailyEnd" width="100%" :lang="$i18n.locale" type="time" format="HH:mm:ss a" placeholder="Select Time" confirm></date-picker>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="eventType">{{ $t("labels.eventType") }}</label>
                            <!--select class="form-control" v-model="event.type" @change="getValues">
                                <option v-for="tp in types" :value="tp" :key="tp">{{ tp }}</option>
                            </select-->
                            <select class="form-control"  v-model="event.type" @change="getValues">
                                <option v-for="tp in types" :value="tp" :key="tp">{{ translatedEventType(tp) }}</option>
                            </select>

                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="type">{{ $t("labels.type") }}</label>
                            <select class="form-control" v-model="typeId">
                                <option v-for="tp in typeList" :value="tp._id" :key="tp._id">{{ tp.name[$i18n.locale] ? tp.name[$i18n.locale] : tp.name['en'] }}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="event.type === 'event'">
                    <div class="col-md-12">
                        <a href="" @click.prevent="lovFormVisibility" class="btn btn-success">{{ this.showLovText }}</a>
                        <h4 class="form-section" v-if="showLovForm">
                            <i class="icon-user"></i>{{ $t("labels.addUserLov") }}
                        </h4>
                        <lov-form :lov="lov" v-if="showLovForm"></lov-form>
                        <div class="form-actions" v-if="showLovForm">
                            <button class="btn btn-success" @click.prevent="saveUserLov">{{ $t("labels.saveEventType") }}</button>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <div class="dropzone image-upload bottom-space">
                            <h5>
                                {{ $t("labels.addSingleImage") }}
                                <span><strong>{{ $t('labels.maxImageSize') }}:</strong><br>5 Mb</span>
                                <span><strong>{{ $t('labels.allowedFormats') }}:</strong><br>{{ $store.state.allowedImageTypesSimple.toString().split(',').join(', ') }}</span>
                            </h5>
                            <input type="file" id="image" ref="image" @change="getImage">
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="input-group">
                            <div class="dropzone bottom-space">
                                <h5>
                                    {{ $t("labels.video") }}
                                    <span><strong>{{ $t('labels.maxVideoSize') }}:</strong><br>50 Mb</span>
                                    <span><strong>{{ $t('labels.allowedFormats') }}:</strong><br>{{ $store.state.allowedVideoTypesSimple.toString().split(',').join(', ') }}</span>
                                </h5>
                                <input type="file" id="video" ref="video" @change="getVideo">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6" v-if="image.name">
                        <div class="row">
                            <div class="col-md-10">
                                <figure>
                                    <img :src="getUrl(image)" alt="index">
                                    <figcaption>{{ image.name }}</figcaption>
                                </figure>
                            </div>
                            <div class="col-md-2">
                                <a class="warning p-0" @click.prevent="deleteImage"><i class="fa fa-trash font-medium-3 mr-2"></i></a>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="row" v-if="video.name">
                            <div class="col-md-10">
                                {{ video.name }}
                            </div>
                            <div class="col-md-2">
                                <a class="warning p-0" @click.prevent="deleteVideo"><i class="fa fa-trash font-medium-3 mr-2"></i></a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group">
                           <label for="eventNotes">{{ $t("labels.notes") }}</label>
                           <textarea id="eventNotes" class="form-control" v-model="event.notes"></textarea>
                        </div>
                    </div>
                </div>
                <div class="form-actions">
                    <button type="button" class="btn btn-success" @click.prevent="saveEvent">
                        <i class="icon-note"></i> {{ $t("labels.save") }}
                    </button>
                </div>
            </form>
        </div>
        <div class="row">
            <div class="col-md-12">
                <calendar-view
                    :show-date="showDate"
                    :events="calendarEvents"
                    :periodChangedCallback="getEventsForPeriod"
                    v-on:click-event="showEvent"
                    v-on:click-date="newEvent"
                    class="theme-default holiday-us-traditional holiday-us-official">
                    <calendar-view-header
                        slot="header"
                        slot-scope="t"
                        :header-props="t.headerProps"
                        @input="setShowDate"
                     />
                </calendar-view>
            </div>
        </div>
    </div>
</template>

<script>
import LovService from '@/services/lov'
import EventService from '@/services/event'
import LovForm from '@/components/lov/LovForm'
import CalendarView from "../shared/vue-simple-calendar/CalendarView.vue"
import CalendarViewHeader from "../shared/vue-simple-calendar/CalendarViewHeader.vue"
import Progress from '@/components/patient/Progress'
import moment from 'moment'
import NewEventModal from '@/components/patient/newEventModal.vue'

export default {
    props: ["patient","selectedEvent"],
    components: {
        CalendarView,
        CalendarViewHeader,
        Progress,
        LovForm,
        NewEventModal
    },
    watch: {
        patient: function(val) {
            this.patientId = val.patientId
        }
    },
    data () {
        return {
            errors: [],
            lovErrors: [],
            patientId: '',
            showDate: new Date(),
            events: [],
            calendarEvents: [],
            types: ['health_state','event'],
            typeList: [],
            typeId: '',
            lov: {
                name: {},
                type: 'event',
                userId: this.$store.state.user._id
            },
            event: {
                periodic: false,
                periodStep: 'weeks',
                periodStart: moment(new Date()).startOf('day').format('YYYY-MM-DD'),
                periodEnd: moment(new Date()).add(30, 'days').endOf('day').format('YYYY-MM-DD'),
                dayOfWeek: 1,
                dailyStart: '8:00',
                dailyEnd: '9:00',
                dayOfMonth: 1,
                startDate: moment(new Date()).format('YYYY-MM-DD'),
                startTime: moment().startOf('day').format('HH:mm:ss'),
                endDate: moment(new Date()).format('YYYY-MM-DD'),
                endTime: moment().endOf('day').format('HH:mm:ss')
            },
            video: {},
            image: {},
            showDate: new Date(),
            showLovForm: false
        }
    },
    computed: {
        typeValue() {
            let result = this.typeList.find(t => t._id === this.typeId)
            let tpval = {
                id: result._id,
                type: result.type,
                name: result.name
            }
            return tpval
        },
        showLovText() {
            if (this.showLovForm) {
                return this.$t("labels.hideEventForm")
            } else {
                return this.$t("labels.addUserLov")
            }
        }
    },
    methods: {
        newEvent(date) {
            this.$emit('neweventmodal', date)
        },
        translatedEventType: function(eventType){
          return this.$t(`lovTypes.${eventType}`)
        },
        getEventsForPeriod(period) {

        },
        lovFormVisibility() {
            this.showLovForm = !this.showLovForm
        },
        getVideo() {
            if (this.$refs.video.files.length > 0) {
                this.video = this.$refs.video.files[0]
                this.event.video = this.$refs.video.files[0]
            }
        },
        deleteVideo() {
            this.$refs.video.value = ''
            this.video = {}
            delete this.event.video
        },
        getImage() {
            this.event.image = this.$refs.image.files[0]
            this.image = this.$refs.image.files[0]
        },
        getUrl(img) {
            return URL.createObjectURL(img)
        },
        deleteImage() {
            this.$refs.image.value = ''
            this.image = {}
            delete this.event.image
        },
        setShowDate(d) {
            this.showDate = d
        },
        saveEvent: async function() {
            let loader = this.$loading.show({
                color: '#ccc',
                loader: 'spinner'
            },{
                after: this.$createElement('Progress')
            })
            this.errors = []
            this.event.patientId = this.patient._id
            if (!this.event.startDate) {
                this.errors.push(this.$t("errors.cantBeEmpty", [this.$t("labels.startDate")]))
            }
            if (!this.event.endDate) {
                this.errors.push(this.$t("errors.cantBeEmpty", [this.$t("labels.endDate")]))
            }
            if (!this.event.type) {
                this.errors.push(this.$t("errors.cantBeEmpty", [this.$t("labels.eventType")]))
            }
            if (!this.typeId || this.typeId.length === 0) {
                this.errors.push(this.$t("errors.cantBeEmpty", [this.$t("labels.typeValue")]))
            }
            const allowedVideoTypes = ['video/mp4','video/x-flv','video/quicktime','video/3gpp','video/x-msvideo','video/x-ms-wmv']
            if (this.event.video && this.event.video.type) {
                if (!allowedVideoTypes.includes(this.event.video.type)) {
                    this.errors.push(this.$t("errors.wrongFiletype", [this.event.video.name]))
                }
                let videSizeMb = this.event.video.size/1024/1024
                if (videSizeMb > 50 ) {
                    this.errors.push(this.$t("errors.tooLarge", [this.event.video.name]))
                }
            }
            const allowedImageTypes = ['image/jpeg', 'image/png', 'image/gif']
            if (this.event.image && this.event.image.type) {
                if (!allowedImageTypes.includes(this.event.image.type)) {
                    this.errors.push(this.$t("errors.wrongFiletype", [this.event.image.name]))
                }
                let imageSizeMb = this.event.image.size/1024/1024
                if (imageSizeMb > 5) {
                    this.errors.push(this.$t("errors.tooLarge", [this.event.image.name]))
                }
            }
            if (this.event.periodic === true) {
                if (!this.event.dailyStart) {
                    this.errors.push(this.$t("errors.cantBeEmpty", [this.$t("labels.dailyStart")]))
                }
                if (!this.event.dailyEnd) {
                    this.errors.push(this.$t("errors.cantBeEmpty", [this.$t("labels.dailyEnd")]))
                }
               if (this.event.periodStep === 'weeks') {
                   if (!this.event.dayOfWeek) {
                        this.errors.push(this.$t("errors.cantBeEmpty", [this.$t("labels.dayOfWeek")]))
                    }
               }
               if (this.event.periodStep === 'months') {
                    if (!this.event.dayOfMonth) {
                        this.errors.push(this.$t("errors.cantBeEmpty", [this.$t("labels.dayOfMonth")]))
                    }
               }
            }
            if (this.errors.length === 0) {
                this.event.typeValue = this.typeValue
                let formData = new FormData()
                formData.append('video', this.event.video)
                formData.append('image', this.event.image)
                formData.append('event', JSON.stringify(this.event))
                let result = await EventService.create(formData)
                if (result) {
                    this.$miniToastr.success(this.$t("flash.createSuccess", [this.$t("models.event")]))
                    this.event = {
                        periodic: false,
                        periodStep: 'weeks',
                        periodStart: moment(new Date()).startOf('day').format('YYYY-MM-DD'),
                        periodEnd: moment(new Date()).add(30, 'days').endOf('day').format('YYYY-MM-DD'),
                        dayOfWeek: 1,
                        dailyStart: '8:00',
                        dailyEnd: '9:00',
                        dayOfMonth: 1,
                        type: '',
                        startDate: moment(new Date()).format('YYYY-MM-DD'),
                        startTime: moment().startOf('day').format('HH:mm'),
                        endDate: moment(new Date()).format('YYYY-MM-DD'),
                        endTime: moment().endOf('day').format('HH:mm')
                    }
                    this.$refs.image.value = ''
                    this.image = {}
                    this.$refs.video.value = ''
                    this.video = {}
                    await this.getEvents()
                } else {
                    this.$miniToastr.error(this.errors.toString().split(",").join("<hr/>"))
                }
            } else {
                this.$miniToastr.error(this.errors.toString().split(",").join("<hr/>"))
                this.event.startDate = moment(new Date()).format('YYYY-MM-DD')
                this.event.endDate = moment(new Date()).format('YYYY-MM-DD')
            }
            loader.hide()
            this.$store.state.currentProgress = 0
        },
        deleteEvent: async function (event, wholePeriod) {
            let result = await EventService.delete(event, wholePeriod)
            if (result) {
                this.$miniToastr.success(this.$t("flash.deleteSuccess", [this.$t("models.event")]))
                await this.getEvents()
            } else {
                this.$miniToastr.error(this.$t("flash.deleteFailed", [this.$t("models.event")]))
            }
        },
        getValues: async function() {
            let result = await LovService.all(this.event.type, false)
            if (result) {
                this.typeList = result.data.filter(function (lv) {
                    return lv.userId === undefined || lv.userId === this.$store.state.user._id
                })
            }
            this.typeList = result.data
        },
        showEvent (event) {
            let current = this.events.find(x => x._id === event.id)
            this.$store.state.eventModalData = current
            $('#eventModal').modal()
        },
        hide () {
            this.$modal.hide('hello-world');
        },
        getEvents: async function() {
            let events = await EventService.all(this.patient._id)
            this.events = events.data
            let eventlist = []
            for (let item in this.events) {
                let current = this.events[item]
                let event = {}
                event.id = current._id
                if (current.typeValue && current.typeValue.name) {
                    event.title = current.typeValue.name[this.$i18n.locale] ? current.typeValue.name[this.$i18n.locale] : current.typeValue.name['en']
                } else {
                    event.title = current.type
                }
                event.startDate = moment(current.startDate).format('YYYY-MM-DD HH:MM:SS')
                event.endDate = moment(current.endDate).format('YYYY-MM-DD HH:MM:SS')
                eventlist.push(event)
            }
            this.calendarEvents = eventlist
        },
        saveUserLov: async function() {
            this.lovErrors = []
            if (!this.lov.name.en || this.lov.name.en.length === 0) {
                this.errors.push(this.$t("errors.nameEnRequired"))
            }
            if (!this.lov.type || this.lov.type.length === 0) {
                this.errors.push(this.$t("errors.typeRequired"))
            }
            if (this.errors.length === 0) {
                let result = await LovService.create(this.lov)
                if (result) {
                    await this.getValues()
                    this.lov = {
                        type: 'event',
                        name: {},
                        userId: this.$store.state.user._id
                    }
                    this.showLovForm = false
                    this.$miniToastr.success(this.$t("flash.createSuccess", [this.$t("models.eventType")]))
                } else {
                    this.$miniToastr.error(this.$t("flash.createFailed", [this.$t("models.eventType")]))
                }
            } else {
                this.$miniToastr.error(this.$t("flash.createFailed", [this.$t("models.eventType")]))
            }
        }
    },
    mounted: async function() {
        await this.getEvents()
        await this.getValues()
    }
}
</script>

<style lang="scss">
    figure {
        max-width: 100%;
        img {
          max-width: 100%;
        }
        video {
          max-width: 100%;
        }
    }
    .dropzone {
        h5 {
            padding: 15px;
            text-align: center;
            max-width: 90%;
            span {
                margin-top: 15px;
                display: block;
                font-size: 12px;

                strong {
                text-transform: uppercase;
                }
            }
        }
    }
</style>


